import gql from 'graphql-tag'

export default gql`query participantsCountByGender($eventId: String!) {
  participantsCountByGender(eventId: $eventId) {
    gender
    count
  }
}`
